import React from 'react';
import { Timeline, Typography, Card, Empty } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import type { WorkflowTransition, RfoPhase } from '@/types/workflow';
import { getPhaseLabel, getPhaseColor } from '@/utils/phaseHelpers';
import dayjs from 'dayjs';

const { Text } = Typography;

interface TransitionHistoryProps {
  transitions: WorkflowTransition[];
}

const TransitionHistory: React.FC<TransitionHistoryProps> = ({ transitions }) => {
  if (!transitions || transitions.length === 0) {
    return (
      <Card title="Phase Transition History" size="small" style={{ marginBottom: 24 }}>
        <Empty
          description="No transitions yet"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </Card>
    );
  }

  // Transitions come sorted DESC from backend (newest first)
  const items = transitions.map((t) => ({
    color: getPhaseColor(t.toPhase as RfoPhase),
    children: (
      <div>
        <div>
          {t.fromPhase ? (
            <>
              <Text strong>{getPhaseLabel(t.fromPhase as RfoPhase)}</Text>
              <ArrowRightOutlined style={{ margin: '0 8px', color: 'var(--color-text-tertiary)' }} />
              <Text strong style={{ color: getPhaseColor(t.toPhase as RfoPhase) }}>
                {getPhaseLabel(t.toPhase as RfoPhase)}
              </Text>
            </>
          ) : (
            <Text strong style={{ color: getPhaseColor(t.toPhase as RfoPhase) }}>
              Started at {getPhaseLabel(t.toPhase as RfoPhase)}
            </Text>
          )}
        </div>
        <div>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {t.transitionedBy || 'System'} &middot;{' '}
            {dayjs(t.transitionedAt).format('MMM D, YYYY h:mm A')}
          </Text>
        </div>
        {t.reason && (
          <div style={{ marginTop: 4 }}>
            <Text italic style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>
              &ldquo;{t.reason}&rdquo;
            </Text>
          </div>
        )}
      </div>
    ),
  }));

  return (
    <Card title="Phase Transition History" size="small" style={{ marginBottom: 24 }}>
      <Timeline items={items} />
    </Card>
  );
};

export default TransitionHistory;
